import { CreateUser } from '@/features/user/components/CreateUser/CreateUser';
import { CreateUserProvider } from '@/features/user/contexts/CreateUserContext';

export const CreateUserPage = () => {
  return (
    <CreateUserProvider>
      <CreateUser />
    </CreateUserProvider>
  );
};
